import React from 'react';
import styles from './CustomSelect.module.scss';
import Select, {components} from 'react-select';
import IconChevronDown from '../Icons/IconChevronDown';

function CustomSelect({options, value}) {
  const DownChevron = ({ children, ...props }) => (
    <components.DropdownIndicator {...props}>
      <i className={styles.arrow}><IconChevronDown/></i>
    </components.DropdownIndicator>

  );

  return (
    <Select
      options={options}
      defaultValue={value}
      className={styles.select}
      autosize={true}
      classNamePrefix={"custom-select"}
      components={{
        DropdownIndicator: DownChevron,
        IndicatorSeparator: () => null
      }}
    />
  );
}

export default CustomSelect;
